const name_templete = {
    name: '类型{n}',
    l_a_name: 'P(A{n})',
    l_a_name_value: 0,
    l_b_name: 'P(B|A{n})',
    l_b_name_value: 0,
    r_a_name: 'P(A{n}|B)',
    r_a_name_value: '-',
    r_b_name: 'P(B|A{n})*P(A{n})',
    r_b_name_value: '-',
    PB_item: 'P(B|A{n})*P(A{n})',
};
const create_new_item = function (index) {
    let new_item = {
        name_object: {
            name: name_templete.name.replace(/\{n\}/g, index),
            value: '未知',
            index: index - 1,
        },
        l_object: {
            a_object: {
                name: name_templete.l_a_name.replace(/\{n\}/g, index),
                value: name_templete.l_a_name_value
            },
            b_object: {
                name: name_templete.l_b_name.replace(/\{n\}/g, index),
                value: name_templete.l_b_name_value
            },

        },

        r_object: {
            a_object: {
                name: name_templete.r_a_name.replace(/\{n\}/g, index),
                value: '-'
            },
            b_object: {
                name: name_templete.r_b_name.replace(/\{n\}/g, index),
                value: '-'
            },

        },

    };
    return new_item;
};
const sample_list = {

    "流沙入海": {
        event_info: {
            event_A: '水流',
            event_B: '含沙',
        },
        items: [{

                name_object: {
                    name: '类型1',
                    value: '长江',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A1)",
                        value: 0.67
                    },
                    b_object: {
                        name: "P(B|A1)",
                        value: 0.01
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A1|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A1)*P(A1)",
                        value: '-'
                    },

                },


            },
            {

                name_object: {
                    name: '类型2',
                    value: '黄河',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A2)",
                        value: 0.05
                    },
                    b_object: {
                        name: "P(B|A2)",
                        value: 0.0378
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A2|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A2)*P(A2)",
                        value: '-'
                    },

                },


            },
            {

                name_object: {
                    name: '类型3',
                    value: '珠江',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A3)",
                        value: 0.23
                    },
                    b_object: {
                        name: "P(B|A3)",
                        value: 0.006
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A3|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A3)*P(A3)",
                        value: '-'
                    },

                },


            },

            {

                name_object: {
                    name: '类型4',
                    value: '黑龙江',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A4)",
                        value: 0.05
                    },
                    b_object: {
                        name: "P(B|A4)",
                        value: 0.002
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A4|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A4)*P(A4)",
                        value: '-'
                    },

                },


            }
        ],

    },


    "乳腺癌诊断": {
        event_info: {
            event_A: '是否患病',
            event_B: '检测为阳性',
        },
        items: [{

                name_object: {
                    name: '类型1',
                    value: '有乳腺癌',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A1)",
                        value: 0.01
                    },
                    b_object: {
                        name: "P(B|A1)",
                        value: 0.80
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A1|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A1)*P(A1)",
                        value: '-'
                    },

                },


            },
            {

                name_object: {
                    name: '类型2',
                    value: '无乳腺癌',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A2)",
                        value: 0.99
                    },
                    b_object: {
                        name: "P(B|A2)",
                        value: 0.1
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A2|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A2)*P(A2)",
                        value: '-'
                    },

                },


            },


        ],

    },
    "次品追责": {
        event_info: {
            event_A: '工人生产的产品',
            event_B: '次品',
        },
        items: [{

                name_object: {
                    name: '类型1',
                    value: '甲',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A1)",
                        value: 0.4
                    },
                    b_object: {
                        name: "P(B|A1)",
                        value: 0.03
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A1|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A1)*P(A1)",
                        value: '-'
                    },

                },


            },
            {

                name_object: {
                    name: '类型2',
                    value: '乙',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A2)",
                        value: 0.6
                    },
                    b_object: {
                        name: "P(B|A2)",
                        value: 0.02
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A2|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A2)*P(A2)",
                        value: '-'
                    },

                },


            }
        ],

    },
    "核酸检测": {
        event_info: {
            event_A: '是否患病',
            event_B: '核酸阳性',
        },
        items: [{

                name_object: {
                    name: '类型1',
                    value: '患病',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A1)",
                        value: 0.001
                    },
                    b_object: {
                        name: "P(B|A1)",
                        value: 0.95
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A1|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A1)*P(A1)",
                        value: '-'
                    },

                },


            },
            {

                name_object: {
                    name: '类型2',
                    value: '非患病',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A2)",
                        value: 0.999
                    },
                    b_object: {
                        name: "P(B|A2)",
                        value: 0.02
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A2|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A2)*P(A2)",
                        value: '-'
                    },

                },


            },


        ],

    },
    "HIV筛查": {
        event_info: {
            event_A: '是否携带HIV病毒',
            event_B: '检测呈阳性',
        },
        items: [{

                name_object: {
                    name: '类型1',
                    value: '携带病毒',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A1)",
                        value: 0.001
                    },
                    b_object: {
                        name: "P(B|A1)",
                        value: 0.95
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A1|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A1)*P(A1)",
                        value: '-'
                    },

                },


            },
            {

                name_object: {
                    name: '类型2',
                    value: '不携带病毒',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A2)",
                        value: 0.999
                    },
                    b_object: {
                        name: "P(B|A2)",
                        value: 0.01
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A2|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A2)*P(A2)",
                        value: '-'
                    },

                },


            },


        ],

    },
    "特征分类": {
        event_info: {
            event_A: '性别',
            event_B: '食指长于无名指',
        },
        items: [{

                name_object: {
                    name: '类型1',
                    value: '男',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A1)",
                        value: 0.5
                    },
                    b_object: {
                        name: "P(B|A1)",
                        value: 0.12
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A1|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A1)*P(A1)",
                        value: '-'
                    },

                },


            },

            {

                name_object: {
                    name: '类型2',
                    value: '女',
                    index: 1
                },
                l_object: {
                    a_object: {
                        name: "P(A2)",
                        value: 0.5
                    },
                    b_object: {
                        name: "P(B|A2)",
                        value: 0.85
                    },

                },

                r_object: {
                    a_object: {
                        name: "P(A2|B)",
                        value: '-'
                    },
                    b_object: {
                        name: "P(B|A2)*P(A2)",
                        value: '-'
                    },

                },


            }
        ]

    },

    "自定义": {
        event_info: {
            event_A: '事件A',
            event_B: '事件B',
        },
        items: [{

            name_object: {
                name: '类型1',
                value: '--',
                index: 1
            },
            l_object: {
                a_object: {
                    name: "P(A1)",
                    value: 0.1
                },
                b_object: {
                    name: "P(B|A1)",
                    value: 0.2
                },

            },

            r_object: {
                a_object: {
                    name: "P(A1|B)",
                    value: '-'
                },
                b_object: {
                    name: "P(B|A1)*P(A1)",
                    value: '-'
                },

            },


        }]

    },

}

export {
    sample_list,
    name_templete,
    create_new_item
}
